export default "__VITE_ASSET__bf5bce99__"